// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: 1,
    link: "https://www.lesmills.com/",
    title: "Les Miles International",
    photo: "projects--item photo1"
  },
  {
    id: 2,
    link: "https://www.unicef.org/",
    title: "Unicef",
    photo: "projects--item photo2"
  },
  {
    id: 3,
    link: "https://www.airnewzealand.co.nz/",
    title: "Air New Zealand",
    photo: "projects--item photo3"
  },
  {
    id: 4,
    link: "https://www.nike.com/",
    title: "Nike",
    photo: "projects--item photo4"
  },
  {
    id: 5,
    link: "https://www.apple.com/",
    title: "Apple",
    photo: "projects--item photo1"
  },
  {
    id: 6,
    link: "https://www.reebok.com/us",
    title: "Reebok",
    photo: "projects--item photo2"
  },
  {
    id: 7,
    link: "https://www.lesmills.com/",
    title: "Less Miles",
    photo: "projects--item photo3"
  },
  {
    id: 8,
    link: "https://www.aquaofficial.com/#/",
    title: "Aqua",
    photo: "projects--item photo4"
  },
  {
    id: 9,
    link: "https://www.jaguar.com/market-selector.html",
    title: "Jaquar",
    photo: "projects--item photo1"
  }
]